import { Button, Result } from 'antd';
import React from 'react';

interface Props {
  // Changing this (e.g. the route path) clears a caught error.
  resetKey: string;
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

// Keeps one bad API response from blanking the whole dashboard.
export class PageErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Page render failed', error, info.componentStack);
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="warning"
          title="This page could not be displayed"
          subTitle="Some data came back in an unexpected format. Please try again."
          extra={
            <Button type="primary" onClick={() => this.setState({ error: null })}>
              Try again
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
